<template>
  <v-container class="customerSetupScreen" fluid text-xs-center>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm8 md5 lg4>
        <div class="customerSetupPanel">
          <img src="../shared/assets/images/logo_new.png" class="customerSetupLogo" alt="MyOrder" />
          <h1>Customer Support</h1>
          <p>The Myorder portal is not currently set up for customer support. Don't worry, though—all of your tools and functionality are fully available to you right now in the app.</p>
          <v-btn color="success" class="customerSetupLogout" @click="fncLogout">Logout</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'CustomerSetup',
  methods: {
    fncLogout() {
      this.$store.dispatch('fncLogout');
    }
  }
}
</script>

<style scoped>
  .customerSetupScreen {
    min-height: 100vh;
    background: #f5f7fb;
  }

  .customerSetupScreen .layout {
    min-height: 100vh;
  }

  .customerSetupPanel {
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.12);
    padding: 42px 34px 36px;
  }

  .customerSetupLogo {
    display: block;
    max-width: 210px;
    width: 70%;
    margin: 0 auto 30px;
  }

  .customerSetupPanel h1 {
    color: #333333;
    font-size: 26px;
    font-weight: 600;
    margin: 0 0 16px;
  }

  .customerSetupPanel p {
    color: #555555;
    font-size: 15px;
    line-height: 1.5;
    margin: 0 0 28px;
  }

  .customerSetupLogout {
    min-width: 120px;
  }
</style>
